import * as CompareActions from './compare.actions';

export interface State {
  audits: any[];
  compareData: any;
  compareStat: any;
}

const initialState: State = {
  audits: [],
  compareData: [],
  compareStat: {}
};

export function compareReducer(state = initialState, action: CompareActions.CompareActions) {
  switch (action.type) {
    case CompareActions.ADD_AUDIT:
      const audits = state.audits;
      let storedIdx: any = -1;
      for(const i in audits) {
        if (audits[i].idx === action.payload.idx) {
          storedIdx = i;
          break;
        }
      }
      if (storedIdx < 0) {
        audits.push(action.payload);
      } else {
        audits[storedIdx] = action.payload;
      }
      return {
        ...state
      };
    case CompareActions.SET_COMPARE_DATA:
      return {
        ...state,
        compareData: action.payload
      };
    case CompareActions.SET_COMPARE_STAT:
      return {
        ...state,
        compareStat: action.payload
      };
    case CompareActions.RESET_AUDITS:
      return {
        ...state,
        audits: []
      };
  }
  return state;
}
